import '../assets/NcMentionBubble-7PQ8wEko.css';
import '../assets/NcAppNavigationSettings-nH_pGlKc.css';
import { r as o, s as r, a } from "./_l10n-BZu8wI2q.mjs";
import l from "../Mixins/clickOutsideOptions.mjs";
import "../Composables/useIsFullscreen.mjs";
import "../Composables/useIsMobile.mjs";
import "@nextcloud/router";
/* empty css                                                                          */
import { n as i } from "./_plugin-vue2_normalizer-Bj5bLKV4.mjs";
import "linkify-string";
import "escape-html";
import "striptags";
import "vue";
import "@nextcloud/auth";
import "@nextcloud/axios";
import "@nextcloud/capabilities";
import { vOnClickOutside as c } from "@vueuse/components";
o(r);
const p = {
  name: "CogIcon",
  emits: ["click"],
  props: {
    title: {
      type: String
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
};
var u = function() {
  var t = this, e = t._self._c;
  return e("span", t._b({ staticClass: "material-design-icon cog-icon", attrs: { "aria-hidden": t.title ? null : !0, "aria-label": t.title, role: "img" }, on: { click: function(n) {
    return t.$emit("click", n);
  } } }, "span", t.$attrs, !1), [e("svg", { staticClass: "material-design-icon__svg", attrs: { fill: t.fillColor, width: t.size, height: t.size, viewBox: "0 0 24 24" } }, [e("path", { attrs: { d: "M12,15.5A3.5,3.5 0 0,1 8.5,12A3.5,3.5 0 0,1 12,8.5A3.5,3.5 0 0,1 15.5,12A3.5,3.5 0 0,1 12,15.5M19.43,12.97C19.47,12.65 19.5,12.33 19.5,12C19.5,11.67 19.47,11.34 19.43,11L21.54,9.37C21.73,9.22 21.78,8.95 21.66,8.73L19.66,5.27C19.54,5.05 19.27,4.96 19.05,5.05L16.56,6.05C16.04,5.66 15.5,5.32 14.87,5.07L14.5,2.42C14.46,2.18 14.25,2 14,2H10C9.75,2 9.54,2.18 9.5,2.42L9.13,5.07C8.5,5.32 7.96,5.66 7.44,6.05L4.95,5.05C4.73,4.96 4.46,5.05 4.34,5.27L2.34,8.73C2.21,8.95 2.27,9.22 2.46,9.37L4.57,11C4.53,11.34 4.5,11.67 4.5,12C4.5,12.33 4.53,12.65 4.57,12.97L2.46,14.63C2.27,14.78 2.21,15.05 2.34,15.27L4.34,18.73C4.46,18.95 4.73,19.03 4.95,18.95L7.44,17.94C7.96,18.34 8.5,18.68 9.13,18.93L9.5,21.58C9.54,21.82 9.75,22 10,22H14C14.25,22 14.46,21.82 14.5,21.58L14.87,18.93C15.5,18.67 16.04,18.34 16.56,17.94L19.05,18.95C19.27,19.03 19.54,18.95 19.66,18.73L21.66,15.27C21.78,15.05 21.73,14.78 21.54,14.63L19.43,12.97Z" } }, [t.title ? e("title", [t._v(t._s(t.title))]) : t._e()])])]);
}, _ = [], m = /* @__PURE__ */ i(
  p,
  u,
  _,
  !1,
  null,
  null,
  null,
  null
);
const d = m.exports, C = {
  directives: {
    ClickOutside: c
  },
  components: {
    Cog: d
  },
  mixins: [
    l
  ],
  props: {
    name: {
      type: String,
      required: !1,
      default: a("Settings")
    }
  },
  data() {
    return {
      open: !1
    };
  },
  computed: {
    clickOutsideConfig() {
      return [
        this.closeMenu,
        this.clickOutsideOptions
      ];
    }
  },
  methods: {
    toggleMenu() {
      this.open = !this.open;
    },
    closeMenu() {
      this.open = !1;
    }
  }
};
var f = function() {
  var t = this, e = t._self._c;
  return e("div", { directives: [{ name: "click-outside", rawName: "v-click-outside", value: t.clickOutsideConfig, expression: "clickOutsideConfig" }], class: { open: t.open }, attrs: { id: "app-settings" } }, [e("div", { attrs: { id: "app-settings__header" } }, [e("button", { staticClass: "settings-button", attrs: { type: "button", "aria-expanded": t.open ? "true" : "false", "aria-controls": "app-settings__content" }, on: { click: t.toggleMenu } }, [e("Cog", { staticClass: "settings-button__icon", attrs: { size: 20 } }), e("span", { staticClass: "settings-button__label" }, [t._v(t._s(t.name))])], 1)]), e("Transition", { attrs: { name: "slide-up" } }, [e("div", { directives: [{ name: "show", rawName: "v-show", value: t.open, expression: "open" }], attrs: { id: "app-settings__content" } }, [t._t("default")], 2)])], 1);
}, g = [], v = /* @__PURE__ */ i(
  C,
  f,
  g,
  !1,
  null,
  "4bd59bb1",
  null,
  null
);
const H = v.exports;
export {
  H as N
};
